import type { Opportunities } from "../types"

export const opportunities: Opportunities = new Map([])
